var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7887_530942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5004 80.0008C62.592 80.0008 80.5008 62.092 80.5008 40.0004C80.5008 17.9088 62.592 0 40.5004 0C18.4088 0 0.5 17.9088 0.5 40.0004C0.5 62.092 18.4088 80.0008 40.5004 80.0008Z",
    fill: "#F2F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 46.8825L43.2139 9L31.605 18.0483L48.3898 35.1015L34 35L28.5047 29.4168L19.5 41.2112L37.9671 59.9737L30.1308 66.8575L43.0657 80C61.5462 78.5591 76.6461 64.8549 80.5 46.8825Z",
    fill: "#C8BCFF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8043 36.7918L59.7808 36.8153L59.8043 36.8388L58.4088 38.2343L58.3853 38.2108L38.356 58.2401L36.9605 56.8447L56.0038 37.8014H28.0625V35.8274H56.0029L36.9605 16.7842L38.356 15.3887L58.3853 35.418L58.4088 35.3945L59.8043 36.79V36.7918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6441 44.671C61.9823 44.671 65.4991 41.1542 65.4991 36.816C65.4991 32.4777 61.9823 28.9609 57.6441 28.9609C53.3059 28.9609 49.7891 32.4777 49.7891 36.816C49.7891 41.1542 53.3059 44.671 57.6441 44.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5039 45.0782C29.0668 45.0782 32.7657 41.3793 32.7657 36.8164C32.7657 32.2536 29.0668 28.5547 24.5039 28.5547C19.9411 28.5547 16.2422 32.2536 16.2422 36.8164C16.2422 41.3793 19.9411 45.0782 24.5039 45.0782Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3835 36.4453H25.6168L25.7976 38.328L26.1193 38.5855L26.7963 39.0167L24.4997 44.4422L22.2031 39.0167L22.881 38.5855L23.2027 38.328L23.3835 36.4453Z",
    fill: "#F2AD74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6479 38.7255L20.7969 39.3166L24.5016 44.4439L27.6541 39.1449L26.3463 38.73L25.1939 39.5426H23.8129L22.6479 38.7246V38.7255Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0889 39.4674L24.247 39.8579L23.8945 44.3073L24.5019 44.7719L25.1093 44.3073L24.7568 39.8579L24.9149 39.4674L24.5019 39.4512L24.0889 39.4674Z",
    fill: "#0F5F9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6802 38.7148L19.4057 39.7606C19.4057 39.7606 18.9818 39.9802 18.8543 40.6508C18.7432 41.2329 18.6808 41.8267 18.5977 42.5931C20.0971 44.126 22.1885 45.0777 24.5032 45.0777C26.8178 45.0777 28.9083 44.126 30.4087 42.5931C30.3255 41.8267 30.2631 41.2338 30.152 40.6508C30.0236 39.9793 29.5997 39.7606 29.5997 39.7606L26.3478 38.7293L24.5032 44.1386L22.6811 38.7148H22.6802Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6822 38.7148L21.9754 38.9408L21.8398 40.7331C21.8398 40.7331 21.8769 40.8804 21.989 40.8677L22.6262 41.1072C22.6262 41.1072 22.6677 41.1488 22.6307 41.2021L22.0857 41.5763L23.934 45.0587C24.1229 45.0713 24.3127 45.0786 24.5043 45.0786C24.6968 45.0786 24.8857 45.0713 25.0746 45.0587L26.9229 41.5763L26.377 41.2021C26.3399 41.1488 26.3815 41.1072 26.3815 41.1072L27.0187 40.8677C27.1308 40.8804 27.1678 40.7331 27.1678 40.7331L27.0331 38.9462L26.349 38.7302L24.5043 44.1386L22.6831 38.7148H22.6822Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9023 32.6162C21.9023 32.7915 21.8381 32.9623 21.8426 33.1304C21.2443 33.0193 21.5326 34.7971 21.8725 35.042C21.8996 35.0619 21.9656 35.0185 22.0216 34.9823C22.1391 35.6367 23.1414 37.3838 23.7786 38.1195C23.9558 38.3237 25.0385 38.3201 25.213 38.1267C25.8655 37.4082 26.8678 35.6394 26.9862 34.9823C27.0414 35.0176 27.1073 35.061 27.1354 35.042C27.4743 34.7971 27.7635 33.0193 27.1643 33.1304C27.1688 32.9623 27.1055 32.7915 27.1055 32.6162C27.073 31.236 25.8221 30.5464 24.5044 30.541C23.1866 30.5473 21.9366 31.236 21.9032 32.6162H21.9023Z",
    fill: "#FFBC86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.703 30.8476C22.515 30.8259 21.8327 31.0347 21.7513 31.756C21.6691 32.4772 21.7088 33.1424 21.7088 33.1424C21.7088 33.1424 22.1083 33.2436 22.1589 33.6531C22.2086 34.0625 22.1725 34.0625 22.1725 34.0625L22.318 34.03L22.421 33.3277C23.0185 32.9535 22.4156 32.3986 23.0139 32.2684C24.6281 33.419 26.0525 33.2219 26.6952 32.6815C26.6952 32.6815 26.5451 33.2473 26.6608 33.4488C26.7765 33.6513 26.7069 33.9685 26.7069 33.9685L26.8569 33.9622C26.8569 33.9622 26.8298 33.128 27.1633 33.1316C28.4296 31.0401 24.4203 28.4426 22.7039 30.8476H22.703Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1874 38.0605C23.2344 38.0633 22.6406 38.733 22.6406 38.733L23.1459 40.4638L24.4998 39.4524C23.755 39.0864 23.3103 38.6128 23.1865 38.0605H23.1874ZM25.8139 38.0605C25.7678 38.0633 26.3607 38.733 26.3607 38.733L25.8555 40.4638L24.5007 39.4524C25.2463 39.0864 25.6901 38.6128 25.8139 38.0605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5647 18.8834C41.1407 18.8834 44.0396 15.9845 44.0396 12.4085C44.0396 8.8325 41.1407 5.93359 37.5647 5.93359C33.9888 5.93359 31.0898 8.8325 31.0898 12.4085C31.0898 15.9845 33.9888 18.8834 37.5647 18.8834Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7539 14.605C35.1579 13.9244 35.796 13.1354 35.1489 11.936C34.1963 7.76946 38.5879 6.9253 39.2513 8.64525C40.3322 9.05197 40.3033 11.2952 39.7484 12.4693C39.7231 12.9519 39.2214 13.3731 40.128 14.6185L40.193 14.6041C39.0163 14.9457 35.9985 14.7885 34.7548 14.605H34.7539Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9088 12.4457C36.2395 13.1407 36.3616 13.4119 36.7728 13.7246C36.7077 14.9239 36.0633 14.9239 35.3457 15.2963L39.9181 15.3975C39.1489 14.9592 38.4268 15.0188 38.3581 13.7246C38.7693 13.4119 38.8913 13.1407 39.223 12.4457C39.3035 12.4882 39.3893 12.5451 39.4553 12.471C39.5204 12.3969 39.834 11.4352 39.778 11.3051C39.6758 11.0701 39.5258 11.5084 39.4924 11.3647C39.4164 10.9851 39.1815 10.5386 39.0974 9.55078C38.1529 11.2969 35.4324 10.5793 35.549 11.3168C35.0185 10.9463 35.6629 12.4565 35.6756 12.471C35.7415 12.5451 35.8265 12.4882 35.9088 12.4457Z",
    fill: "#FFBC86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.776 13.7255C36.7579 14.0554 36.6965 14.2949 36.6016 14.4757L37.6319 15.0912L38.5601 14.5362C38.4508 14.3455 38.3803 14.0888 38.3604 13.7246C38.1408 13.8882 37.9772 14.0635 37.6382 14.0635C37.2839 14.0644 37.095 13.8936 36.776 13.7246V13.7255Z",
    fill: "#F2AD74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5553 14.5519C36.4387 14.7344 36.2823 14.851 36.1016 14.9486L37.6191 17.8246L39.0272 14.9459C38.8247 14.8375 38.6548 14.7028 38.5364 14.4805L37.5739 14.9586L37.544 14.9604L36.689 14.5031L36.5544 14.5519H36.5553Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3281 14.9707L37.4185 15.2383L37.2188 18.2895L37.5622 18.6077L37.9065 18.2895L37.7068 15.2383L37.7972 14.9707L37.5622 14.959L37.3272 14.9707H37.3281Z",
    fill: "#0F5F9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1027 14.9491C35.5984 15.2175 34.6747 14.893 34.0999 15.8222C34.0275 15.9378 33.9851 16.9691 33.8359 17.6994C34.8907 18.445 36.1777 18.8834 37.5678 18.8834C38.9596 18.8834 40.2494 18.4441 41.305 17.6967C41.1713 16.9673 41.1731 15.9378 41.1017 15.8231C40.5241 14.8912 39.5345 15.2184 39.0292 14.9473L37.6211 17.8259L36.1036 14.95L36.1027 14.9491Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6623 14.2109L36.4336 14.6872L37.1133 15.8306L37.5579 14.9593L36.6623 14.2118V14.2109ZM38.4681 14.2109L38.7013 14.6764L38.0171 15.8297L37.5733 14.9584L38.469 14.2109H38.4681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2166 14.8818L37.5768 17.5308L38.9163 14.8827C38.9841 14.9251 39.0555 14.964 39.1314 15.0002L37.5768 18.037L36.0078 14.9965C36.0819 14.9613 36.1506 14.9233 36.2166 14.8809V14.8818Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5673 74.3378C43.3366 74.3378 48.0136 69.6609 48.0136 63.8916C48.0136 58.1223 43.3366 53.4453 37.5673 53.4453C31.798 53.4453 27.1211 58.1223 27.1211 63.8916C27.1211 69.6609 31.798 74.3378 37.5673 74.3378Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1563 63.4219H38.9807L39.2084 65.8025L39.6151 66.1288L40.472 66.6738L37.568 73.5337L34.6641 66.6738L35.5209 66.1288L35.9276 65.8025L36.1563 63.4219Z",
    fill: "#F2AD74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2228 66.3047L32.8828 67.0521L37.5673 73.5343L41.5522 66.8352L39.8991 66.311L38.4422 67.3386H36.696L35.2228 66.3047Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0418 67.2434L37.2415 67.7369L36.7969 73.3622L37.5642 73.9497L38.3324 73.3622L37.8869 67.7369L38.0866 67.2434L37.5642 67.2227L37.0418 67.2434Z",
    fill: "#0F5F9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2641 66.293L31.1238 67.6152C31.1238 67.6152 30.5878 67.8927 30.426 68.7414C30.285 69.478 30.2064 70.2282 30.1016 71.197C31.9978 73.1348 34.6414 74.3387 37.5679 74.3387C40.4936 74.3387 43.1381 73.1348 45.0343 71.197C44.9295 70.2282 44.8508 69.478 44.7099 68.7414C44.5481 67.8936 44.0121 67.6152 44.0121 67.6152L39.9007 66.3119L37.5688 73.1511L35.265 66.2939L35.2641 66.293Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.26 66.2919L34.367 66.5775L34.1953 68.8425C34.1953 68.8425 34.2423 69.0296 34.3842 69.0133L35.1904 69.3161C35.1904 69.3161 35.2428 69.3685 35.1958 69.4354L34.5053 69.9081L36.8426 74.3114C37.0812 74.3268 37.3207 74.3367 37.5638 74.3367C37.806 74.3367 38.0455 74.3268 38.2851 74.3114L40.6214 69.9081L39.9318 69.4354C39.8848 69.3685 39.9372 69.3161 39.9372 69.3161L40.7425 69.0133C40.8844 69.0296 40.9314 68.8425 40.9314 68.8425L40.7606 66.5839L39.8956 66.31L37.5638 73.1482L35.26 66.291V66.2919Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2789 58.5827C34.2789 58.8042 34.1976 59.0211 34.2039 59.2335C33.4474 59.0925 33.8117 61.3403 34.241 61.6494C34.2753 61.6747 34.3585 61.6196 34.429 61.5744C34.5772 62.4013 35.8452 64.6103 36.6505 65.5403C36.8747 65.7979 38.244 65.7943 38.4654 65.5493C39.2906 64.641 40.5568 62.405 40.7068 61.5744C40.7773 61.6196 40.8605 61.6747 40.8948 61.6494C41.3232 61.3403 41.6884 59.0925 40.9319 59.2335C40.9382 59.0211 40.8569 58.8051 40.8569 58.5827C40.8153 56.8375 39.2336 55.9662 37.5679 55.959C35.9013 55.9662 34.3205 56.8375 34.2789 58.5827Z",
    fill: "#FFBC86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2934 56.3447C35.0548 56.3176 34.1926 56.5815 34.0895 57.4935C33.9856 58.4054 34.0353 59.246 34.0353 59.246C34.0353 59.246 34.5396 59.3743 34.6038 59.8913C34.6671 60.4092 34.621 60.4092 34.621 60.4092L34.8045 60.3676L34.9346 59.4801C35.6902 59.0074 34.9283 58.3051 35.6839 58.1415C37.7256 59.5967 39.526 59.3472 40.3385 58.6639C40.3385 58.6639 40.1487 59.3797 40.2951 59.6346C40.4406 59.8904 40.3539 60.2917 40.3539 60.2917L40.5437 60.2835C40.5437 60.2835 40.5093 59.2288 40.9305 59.2342C42.532 56.5906 37.4617 53.3061 35.2916 56.3465L35.2934 56.3447Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9063 65.4629C35.9659 65.4665 35.2148 66.3125 35.2148 66.3125L35.8538 68.5006L37.5666 67.2226C36.6248 66.7599 36.0617 66.1615 35.9063 65.4629ZM39.2269 65.4629C39.1681 65.4665 39.9183 66.3125 39.9183 66.3125L39.2793 68.5006L37.5666 67.2226C38.5083 66.7599 39.0705 66.1615 39.2269 65.4629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.646 42.9971C61.0598 42.9971 63.8272 40.2297 63.8272 36.8159C63.8272 33.4022 61.0598 30.6348 57.646 30.6348C54.2322 30.6348 51.4648 33.4022 51.4648 36.8159C51.4648 40.2297 54.2322 42.9971 57.646 42.9971Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5129 32.3711H58.7833V35.6808H62.093V37.9512H58.7833V41.261H56.5129V37.9512H53.2031V35.6808H56.5129V32.3711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5665 52.9584C43.6049 52.9584 48.4999 57.8526 48.4999 63.8918C48.4999 69.9302 43.6049 74.8252 37.5665 74.8252C31.5282 74.8252 26.6331 69.9302 26.6331 63.8918C26.6331 57.8535 31.5282 52.9584 37.5665 52.9584ZM24.5029 27.8135C29.4756 27.8135 33.5066 31.8445 33.5066 36.8173C33.5066 41.7891 29.4756 45.8201 24.5029 45.8201C19.531 45.8201 15.5 41.7891 15.5 36.8173C15.5 31.8445 19.531 27.8135 24.5029 27.8135ZM37.5665 5.17578C41.5614 5.17578 44.7988 8.41413 44.7988 12.4081C44.7988 16.4029 41.5614 19.6404 37.5665 19.6404C33.5717 19.6404 30.3342 16.4029 30.3342 12.4081C30.3342 8.41323 33.5726 5.17578 37.5665 5.17578Z",
    stroke: "white",
    strokeWidth: 2.16782
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7887_530942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.2c20761db4d822975c8577a47440307c.svg";
export { ForwardRef as ReactComponent };